import { styled } from "@mui/system";

import { Skeleton } from "@mui/material";

/* Styled Components */

const MainContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	height: "100%",
}));

const ChipRow = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "0.5rem",
	padding: "0.75rem 0rem",
}));

const ContentRow = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "100%",
	gap: "1rem",
	marginTop: "0.5rem",
}));

const FilterDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "25%",
	minWidth: "25%",
	gap: "1rem",
}));

const CardsContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "75%",
	gap: "0.75rem",
}));

const ShowingResultsRow = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "0.75rem",
	width: "100%",
}));

const CardsRow = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "100%",
	gap: "1rem",
	rowGap: "1rem",
	flexWrap: "wrap",
}));

const CardSkeleton = styled(Skeleton)(({ theme }) => ({
	borderRadius: "0.5rem",
	width: "calc(33.33% - 0.67rem)",
	height: "20rem",
}));

const SearchDesktopLayoutSkeleton = () => {
	return (
		<MainContainer>
			{/* Search bar */}
			<Skeleton
				animation="wave"
				variant="rectangular"
				width="100%"
				height="3.5rem"
				sx={{ borderRadius: "1rem" }}
			/>

			{/* Main content: filters + cards */}
			<ContentRow>
				{/* Left side panel */}
				<FilterDiv>
					{/* Applied Filters */}
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="100%"
						height="6rem"
						sx={{ borderRadius: "1rem" }}
					/>
					{/* Budget */}
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="100%"
						height="14rem"
						sx={{ borderRadius: "1rem" }}
					/>
					{/* Property Category */}
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="100%"
						height="9rem"
						sx={{ borderRadius: "1rem" }}
					/>
					{/* Property Type */}
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="100%"
						height="9rem"
						sx={{ borderRadius: "1rem" }}
					/>
				</FilterDiv>

				{/* Right side */}
				<CardsContainer>
					{/* Filter chips row */}
					<ChipRow>
						{[
							"8rem",
							"5rem",
							"7rem",
							"5rem",
							"5rem",
						].map((w, i) => (
							<Skeleton
								key={`chip-${i}`}
								animation="wave"
								variant="rectangular"
								width={w}
								height="2rem"
								sx={{ borderRadius: "0.5rem", flexShrink: 0 }}
							/>
						))}
						<div style={{ flex: 1 }} />
						<Skeleton
							animation="wave"
							variant="rectangular"
							width="5rem"
							height="2rem"
							sx={{ borderRadius: "0.5rem", flexShrink: 0 }}
						/>
					</ChipRow>
					{/* Showing results row */}
					<ShowingResultsRow>
						<Skeleton
							animation="wave"
							variant="text"
							width="12rem"
							height="1.5rem"
							sx={{ flexShrink: 0 }}
						/>
						<Skeleton
							animation="wave"
							variant="rectangular"
							width="100%"
							height="1px"
							sx={{ flex: 1 }}
						/>
					</ShowingResultsRow>

					{/* Property cards grid - 3 per row */}
					<CardsRow>
						{[...Array(9)].map((_, index) => (
							<CardSkeleton
								key={`skeleton-card-${index}`}
								animation="wave"
								variant="rectangular"
							/>
						))}
					</CardsRow>
				</CardsContainer>
			</ContentRow>
		</MainContainer>
	);
};

export default SearchDesktopLayoutSkeleton;
